<div
  class="grid grid-cols-1 gap-6 lg:grid-cols-[minmax(12rem,1fr)_minmax(0,4fr)]">
  <h2 class="text-standard-text-primary ml-8 text-2xl font-semibold">
    {{ cmsTextProvider.appearanceText.fontHeader }}
  </h2>

  <div class="min-w-0">
    <p class="text-standard-text-secondary mb-5 text-base leading-6">
      {{ cmsTextProvider.appearanceText.fontHint }}
    </p>

    <p class="text-standard-text-secondary mb-3 text-sm">
      {{ cmsTextProvider.appearanceText.fontActiveLabel }}
      {{ activeFontName() }}
    </p>

    <div class="flex justify-end gap-3 pb-3">
      @if (
        state() === 'uploading' || state() === 'preview' || state() === 'error'
      ) {
        <button
          type="button"
          class="text-primary-main px-2 font-semibold"
          (click)="cancelUpload()">
          {{ cmsTextProvider.shared.cancel }}
        </button>
      }

      @if (state() === 'active') {
        <button
          type="button"
          class="text-primary-main px-2 font-semibold"
          (click)="openResetDialog()">
          {{ cmsTextProvider.appearanceText.fontRestoreDefault }}
        </button>
      }

      @if (state() === 'preview') {
        <aw-button
          id="apply-font"
          type="button"
          [isFullWidth]="false"
          [text]="cmsTextProvider.appearanceText.fontApply"
          (click)="applyFont()">
          <span class="material-symbols-rounded pr-2 text-lg">check</span>
        </aw-button>
      } @else {
        <aw-button
          id="upload-font"
          type="button"
          [style]="'primary-alt'"
          [isFullWidth]="false"
          [isDisabled]="state() === 'uploading'"
          (click)="fontInput.click()">
          <span class="material-symbols-rounded pr-2 text-lg">upload</span>
          <span>
            {{
              state() === 'active'
                ? cmsTextProvider.appearanceText.fontChange
                : cmsTextProvider.appearanceText.fontUpload
            }}
          </span>
        </aw-button>
      }
    </div>

    <input
      #fontInput
      type="file"
      hidden
      accept=".ttf,.woff2,font/ttf,font/woff2"
      (change)="selectFile($event)" />

    @if (state() === 'idle' || state() === 'error') {
      <button
        type="button"
        class="text-standard-text-secondary flex min-h-16 w-full items-center justify-center border border-dashed px-4 text-base"
        [ngClass]="
          isDragging() ? 'border-primary-main bg-blue-50' : 'border-neutral-300'
        "
        (click)="fontInput.click()"
        (dragover)="handleDragOver($event)"
        (dragleave)="handleDragLeave($event)"
        (drop)="handleDrop($event)">
        {{ cmsTextProvider.appearanceText.fontDropHint }}
      </button>
    }

    @if (state() === 'uploading') {
      <div class="rounded-md border border-neutral-300 bg-white px-4 py-4">
        <div class="flex items-center gap-4">
          <span class="material-symbols-rounded text-3xl text-neutral-500">
            description
          </span>
          <div class="min-w-0 flex-1">
            <p class="truncate text-base">{{ displayedFilename() }}</p>
            <p class="text-standard-text-secondary text-sm">
              {{ displayedFileSize() }}
            </p>
          </div>
          <div class="h-1.5 w-1/2 overflow-hidden rounded-full bg-blue-100">
            <span class="font-upload-progress block h-full bg-blue-500"></span>
          </div>
        </div>
      </div>
    }

    @if (state() === 'preview' || state() === 'active') {
      <div
        class="flex items-center gap-4 rounded-md border border-neutral-200 bg-white px-4 py-4">
        <span class="material-symbols-rounded text-3xl text-neutral-500">
          description
        </span>
        <div class="min-w-0 flex-1">
          <p class="truncate text-base">{{ displayedFilename() }}</p>
          <p class="text-standard-text-secondary text-sm">
            {{ displayedFileSize() }}
          </p>
        </div>
        @if (state() === 'active') {
          <span
            class="flex items-center gap-1 rounded-full bg-green-100 px-3 py-1 text-sm text-green-800">
            <span class="material-symbols-rounded text-base">check</span>
            {{ cmsTextProvider.appearanceText.fontActive }}
          </span>
        }
      </div>

      <div
        class="font-preview mt-3 rounded-md border border-neutral-200 bg-white p-4"
        [style.fontFamily]="previewFontFamily">
        <p class="text-base">
          {{ cmsTextProvider.appearanceText.fontPreviewUppercase }}
        </p>
        <p class="text-base">
          {{ cmsTextProvider.appearanceText.fontPreviewLowercase }}
        </p>
        <p class="mt-2 text-base">
          {{ cmsTextProvider.appearanceText.fontPreviewSymbols }}
        </p>
        <p class="mt-2 text-2xl leading-7">
          {{ cmsTextProvider.appearanceText.fontPreviewSample }}
        </p>
        <p class="mt-1 text-lg">
          {{ cmsTextProvider.appearanceText.fontPreviewSample }}
        </p>
        <p class="text-standard-text-secondary mt-2 text-sm">
          {{ cmsTextProvider.appearanceText.fontPreviewSample }}
        </p>
      </div>
    }

    @if (state() === 'error') {
      <div
        class="mt-3 flex items-center gap-2 rounded-md bg-red-100 px-4 py-3 text-red-900">
        <span class="material-symbols-rounded text-xl">cancel</span>
        <span>{{ errorMessage() }}</span>
      </div>
    }
  </div>
</div>
